// size chart popup on product page made by Lorna
        document.addEventListener('DOMContentLoaded', function () {
            let openBtn = document.getElementById('openSizeChart');
            let closeBtn = document.getElementById('closeSizeChart');
            let modal = document.getElementById('sizeChartModal');

            openBtn.addEventListener('click', function() {
                document.body.appendChild(modal);
                setTimeout(() => modal.classList.add('show'), 50);
            });

            closeBtn.addEventListener('click', function() {
                modal.classList.remove('show');
            });

            window.onclick = function(event) {
                if (event.target == modal) {
                    modal.classList.remove('show');
                }
            };
        });

        function toggleUnit(unit) {
            document.querySelectorAll('.unit-buttons__select').forEach(button => {
                button.classList.remove('is-active');
            });
            document.querySelector(`.unit-buttons__select[onclick="toggleUnit('${unit}')"]`).classList.add('is-active');

            document.querySelectorAll('.inch').forEach(el => el.style.display = (unit === 'inch' ? 'block' : 'none'));
            document.querySelectorAll('.cm').forEach(el => el.style.display = (unit === 'cm' ? 'block' : 'none'));
        }